/**
 * Is @childElement a child of @parentElement ?
 */
export function domIsChildOf(childElement: HTMLElement, parentElement: HTMLElement | HTMLElement[]): boolean {
  // Elements don't exist anymore
  if (!childElement || !parentElement) {
    return false;
  }

  // Always make parent element an array
  const parentElements: HTMLElement[] = Array.isArray(parentElement) ? parentElement : [parentElement];

  // At least one parent element contains the child element
  return parentElements.some((element) => element.contains(childElement));
}
